// extracted by mini-css-extract-plugin
export default {"root":"CkaPqwuC","sizeMedium":"xAPbskYp","sizeLarge":"DcfVUkTr","stylePrimary":"gRLv2fAR","isLoading":"gfTHnEj0","styleSecondary":"QTLPixSm","fade-in":"DqOzcL+y","spin":"NgnHOSAj"};